import React, { useEffect, useState } from 'react';
import { useReveal } from '../lib/useReveal';
const CHECKOUT_BASE = 'https://academiaholisticaargentina.com/cart/48929044562170:1';
function getSecondsUntilEndOfDay() {
  const now = new Date();
  const end = new Date(now);
  end.setHours(23, 59, 0, 0);
  const diff = Math.floor((end.getTime() - now.getTime()) / 1000);
  return diff > 0 ? diff : 0;
}
export function ClosingSection() {
  const [ref1, vis1] = useReveal();
  const [timeLeft, setTimeLeft] = useState(getSecondsUntilEndOfDay);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(getSecondsUntilEndOfDay());
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  return <section className="relative bg-[#3d2a5f] text-white py-12 md:py-16 px-5 sm:px-6 overflow-hidden border-t border-[#4d3a6f]" data-id="element-110">
      <div ref={ref1} className={`reveal container mx-auto max-w-3xl text-center relative z-10 ${vis1 ? 'is-visible' : ''}`} data-id="element-111">
        <p className="text-white font-serif italic text-2xl md:text-3xl font-bold mb-10" data-id="element-112">
          El próximo paso en tu camino puede empezar hoy.
          <br data-id="element-113" />
          <span className="text-[#c9a14d]" data-id="element-114">
            "El momento que siempre esperaste ya llegó." 🪷
          </span>
        </p>

        <div className="mb-10" data-id="element-115">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-4 leading-tight" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-116">
            ⏰ EL PRECIO CIERRA EN:
          </h2>

          <div className="flex items-center justify-center gap-2" data-id="element-117">
            <span className="bg-[#4d3a6f] border border-white/10 text-white px-3 py-2 rounded-lg text-2xl md:text-3xl font-bold" style={{
            fontFamily: "'Bebas Neue', sans-serif",
            letterSpacing: '0.1em'
          }} data-id="element-118">
              {String(hours).padStart(2, '0')}
            </span>
            <span className="text-white/50 text-xl font-bold" data-id="element-119">hs</span>
            <span className="text-[#c9a14d] text-2xl font-bold animate-pulse" data-id="element-120">
              :
            </span>
            <span className="bg-[#4d3a6f] border border-white/10 text-white px-3 py-2 rounded-lg text-2xl md:text-3xl font-bold" style={{
            fontFamily: "'Bebas Neue', sans-serif",
            letterSpacing: '0.1em'
          }} data-id="element-121">
              {String(minutes).padStart(2, '0')}
            </span>
            <span className="text-white/50 text-xl font-bold" data-id="element-122">min</span>
            <span className="text-[#c9a14d] text-2xl font-bold animate-pulse" data-id="element-123">
              :
            </span>
            <span className="bg-[#4d3a6f] border border-white/10 text-white px-3 py-2 rounded-lg text-2xl md:text-3xl font-bold" style={{
            fontFamily: "'Bebas Neue', sans-serif",
            letterSpacing: '0.1em'
          }} data-id="element-124">
              {String(seconds).padStart(2, '0')}
            </span>
            <span className="text-white/50 text-xl font-bold" data-id="element-125">seg</span>
          </div>
        </div>

        <div className="max-w-md mx-auto mb-10" data-id="element-126">
          {/* Single Product CTA */}
          <div className="bg-[#4d3a6f] rounded-2xl p-6 sm:p-8 border-2 border-[#c9a14d]/50 flex flex-col justify-between relative shadow-[0_20px_50px_rgba(0,0,0,0.3)]" data-id="element-127">
            <div className="mb-6" data-id="element-128">
              <h3 className="text-2xl font-bold text-white mb-2" style={{
              fontFamily: "'Playfair Display', serif"
            }} data-id="element-129">
                MEGAPACK MAESTRÍA REIKI
              </h3>
              <p className="text-[#c9a14d] font-bold text-sm mb-4" data-id="element-130">
                6 Tomos + 6 Bonos · Niveles I, II y Maestría
              </p>
              <p className="text-white/50 text-sm line-through" data-id="element-131">$69.000</p>
              <p className="text-5xl sm:text-6xl font-extrabold text-white" style={{
              textShadow: '0 0 30px rgba(255,255,255,0.1)'
            }} data-id="element-132">
                $19.990{' '}
                <span className="text-xl font-bold text-white/70" data-id="element-133">ARS</span>
              </p>
            </div>
            <a href={CHECKOUT_BASE} target="_blank" rel="noopener noreferrer" className="w-full block px-4 py-4 rounded-xl text-white font-bold text-sm sm:text-base tracking-widest uppercase transition-all shadow-[0_10px_30px_rgba(201,161,77,0.4)] hover:shadow-[0_15px_40px_rgba(201,161,77,0.5)] hover:-translate-y-1 bg-gradient-to-r from-[#c9a14d] to-[#b8945a] border border-[#c9a14d] text-center" style={{
            fontFamily: "'Inter', sans-serif",
            letterSpacing: '0.05em'
          }} data-id="element-134">
              → QUIERO MI MEGAPACK
            </a>
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-4 md:gap-6 text-white/60 text-xs md:text-sm font-medium" data-id="element-135">
          <span className="flex items-center gap-1.5" data-id="element-136">🔒 Pago 100% seguro</span>
          <span className="flex items-center gap-1.5" data-id="element-137">
            ⚡ Acceso en 5 minutos
          </span>
          <span className="flex items-center gap-1.5" data-id="element-138">🛡️ Garantía 7 días</span>
          <span className="flex items-center gap-1.5" data-id="element-139">
            💳 Mercado Pago | Tarjeta | Transferencia
          </span>
        </div>
      </div>
    </section>;
}